/* Delivery date estimate: business-day maths in the dispatch time zone. The server-rendered
 * business-day range stays in place when this script does not run. No network calls. */
(function (scope) {
  'use strict';
  var api = scope.Top1Delivery || {};
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function key(date) { return date.getUTCFullYear() + '-' + pad(date.getUTCMonth() + 1) + '-' + pad(date.getUTCDate()); }
  function parseHolidays(raw) {
    var set = {};
    String(raw || '').split(/[\s,]+/).forEach(function (value) { if (/^\d{4}-\d{2}-\d{2}$/.test(value)) set[value] = true; });
    return set;
  }
  function isBusinessDay(date, holidays) { var day = date.getUTCDay(); return day !== 0 && day !== 6 && !holidays[key(date)]; }
  function addDays(date, days) { var next = new Date(date.getTime()); next.setUTCDate(next.getUTCDate() + days); return next; }
  // Move forward `count` business days. Zero means "this day if it is a business day, otherwise the next one".
  function addBusinessDays(date, count, holidays) {
    var current = new Date(date.getTime());
    if (count <= 0) { while (!isBusinessDay(current, holidays)) current = addDays(current, 1); return current; }
    var moved = 0;
    while (moved < count) { current = addDays(current, 1); if (isBusinessDay(current, holidays)) moved++; }
    return current;
  }
  // Wall-clock date and minutes in an IANA time zone, as a UTC-midnight Date for calendar maths.
  function zonedNow(now, zone) {
    try {
      var parts = new Intl.DateTimeFormat('en-US', { timeZone: zone, year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }).formatToParts(now);
      var get = function (type) { for (var i = 0; i < parts.length; i++) if (parts[i].type === type) return Number(parts[i].value); return NaN; };
      var hour = get('hour') % 24;
      var date = new Date(Date.UTC(get('year'), get('month') - 1, get('day')));
      if (isNaN(date.getTime()) || isNaN(hour)) return null;
      return { date: date, minutes: hour * 60 + get('minute') };
    } catch (e) { return null; }
  }
  function parseCutoff(value) {
    var match = /^([01]\d|2[0-3]):([0-5]\d)$/.exec(String(value || ''));
    return match ? Number(match[1]) * 60 + Number(match[2]) : null;
  }
  function estimate(options) {
    var holidays = typeof options.holidays === 'object' && options.holidays ? options.holidays : parseHolidays(options.holidays);
    var local = zonedNow(options.now || new Date(), options.zone);
    if (!local) return null;
    var dispatchMin = Math.max(0, options.dispatchMin | 0), dispatchMax = Math.max(dispatchMin, options.dispatchMax | 0);
    var transitMin = Math.max(0, options.transitMin | 0), transitMax = Math.max(transitMin, options.transitMax | 0);
    var cutoff = parseCutoff(options.cutoff), today = local.date, sameDay = false, firstDispatch, lastDispatch;
    if (cutoff != null) {
      // An owner-set cut-off asserts same-day dispatch before that time on a dispatch day.
      sameDay = isBusinessDay(today, holidays) && local.minutes < cutoff;
      firstDispatch = lastDispatch = sameDay ? today : addBusinessDays(today, 1, holidays);
    } else {
      firstDispatch = addBusinessDays(today, dispatchMin, holidays);
      lastDispatch = addBusinessDays(today, dispatchMax, holidays);
    }
    return {
      today: today, sameDay: sameDay, cutoffMinutes: cutoff,
      firstDispatch: firstDispatch, lastDispatch: lastDispatch,
      earliest: addBusinessDays(firstDispatch, transitMin, holidays),
      latest: addBusinessDays(lastDispatch, transitMax, holidays)
    };
  }
  // One stable shape per market, whatever the browser's ICU version: 'Tue 27 Oct' (AU) and 'Tue, Oct 27' (US, CA).
  function formatDate(date, locale) {
    var lang = locale || 'en-AU', values = {};
    try {
      new Intl.DateTimeFormat(lang, { weekday: 'short', day: 'numeric', month: 'short', timeZone: 'UTC' }).formatToParts(date)
        .forEach(function (part) { values[part.type] = part.value; });
    } catch (e) {}
    if (!values.weekday || !values.day || !values.month) return key(date);
    var month = values.month.replace(/\.$/, '');
    return /^en-(US|CA)$/.test(lang) ? values.weekday + ', ' + month + ' ' + values.day : values.weekday + ' ' + values.day + ' ' + month;
  }
  function formatCutoff(minutes, locale, zone, now) {
    var hours = Math.floor(minutes / 60), mins = minutes % 60, suffix = hours < 12 ? 'am' : 'pm', twelve = hours % 12 || 12;
    var label = twelve + (mins ? ':' + pad(mins) : '') + suffix, abbreviation = '';
    try {
      var parts = new Intl.DateTimeFormat(locale || 'en-AU', { timeZone: zone, timeZoneName: 'short' }).formatToParts(now || new Date());
      for (var i = 0; i < parts.length; i++) if (parts[i].type === 'timeZoneName') abbreviation = parts[i].value;
    } catch (e) {}
    // Skip opaque offsets such as GMT+10; the shopper sees the plain time instead.
    if (/^[A-Z]{2,5}$/.test(abbreviation)) label += ' ' + abbreviation;
    return label;
  }
  function render(root, now) {
    if (!root || root.dataset.deliveryReady === '1') return;
    var data = root.dataset, locale = data.deliveryLocale || 'en-AU';
    var result = estimate({ now: now, zone: data.deliveryZone, holidays: data.holidays, cutoff: data.cutoff, dispatchMin: Number(data.dispatchMin), dispatchMax: Number(data.dispatchMax), transitMin: Number(data.transitMin), transitMax: Number(data.transitMax) });
    if (!result) return;
    var text = root.querySelector('[data-delivery-text]'), cut = root.querySelector('[data-delivery-cutoff]');
    var first = formatDate(result.earliest, locale), last = formatDate(result.latest, locale);
    if (text) {
      // Copy from the WS-E package; gifts get the latest date only, never a promise.
      text.textContent = '';
      if (data.deliveryContext === 'gift') {
        text.appendChild(document.createTextNode('Buying a gift? With standard delivery, allow until ' + last + '.'));
      } else {
        var strong = document.createElement('strong'); strong.textContent = 'Standard delivery:';
        text.appendChild(strong);
        text.appendChild(document.createTextNode(' usually ' + (first === last ? first : first + ' to ' + last) + '.'));
      }
    }
    if (cut) {
      cut.hidden = !result.sameDay;
      if (result.sameDay) cut.textContent = 'Order by ' + formatCutoff(result.cutoffMinutes, locale, data.deliveryZone, now) + ' for dispatch today.';
    }
    root.dataset.deliveryReady = '1';
  }
  function hideExpired(root, now) {
    var until = root.dataset.xmasUntil, local = zonedNow(now || new Date(), root.dataset.xmasZone || 'UTC');
    if (until && local && key(local.date) > until) root.hidden = true;
  }
  function init(container) {
    var scopeNode = container || document;
    Array.prototype.forEach.call(scopeNode.querySelectorAll('[data-top1-delivery]'), function (root) { render(root); });
    Array.prototype.forEach.call(scopeNode.querySelectorAll('[data-top1-xmas]'), function (root) { hideExpired(root); });
  }
  api.parseHolidays = parseHolidays; api.addBusinessDays = addBusinessDays; api.isBusinessDay = isBusinessDay;
  api.zonedNow = zonedNow; api.estimate = estimate; api.formatDate = formatDate; api.formatCutoff = formatCutoff;
  api.render = render; api.init = init; api.key = key;
  scope.Top1Delivery = api;
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (typeof document !== 'undefined' && !api.listening) {
    api.listening = true;
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
    else init(document);
    // Cart quantity changes re-render the cart footer; re-apply dates to the new markup.
    var footer = document.getElementById('main-cart-footer');
    if (footer && typeof MutationObserver !== 'undefined') {
      var pending = false;
      new MutationObserver(function () {
        if (pending) return; pending = true;
        setTimeout(function () { pending = false; init(footer); }, 50);
      }).observe(footer, { childList: true, subtree: true });
    }
    document.addEventListener('shopify:section:load', function (event) { init(event.target); });
  }
})(typeof window !== 'undefined' ? window : globalThis);
